<template lang="pug">
  div.app-line
    span.app-line-title {{title}}
    span.app-line-text
      v-icon(v-if="val === map[0]" color="white" style="vertical-align:bottom") hourglass_empty
      v-progress-circular(v-if="val === map[1]" indeterminate color="white" size=22)
      v-icon(v-if="val === map[2]" color="white" style="vertical-align:bottom") check_circle
</template>

<script>
export default {
  props: {
    val: { type: Number, required: true },
    title: { type: String, required: true },
    map: { type: Array, default: () => [0, 1, 2] }
  }
}
</script>

<style scoped lang="stylus">
</style>



// WEBPACK FOOTER //
// src/app/pages/Order/Request/progress.vue